import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import IssueReportForm from '../IssueReport/IssueReportForm';
import styles from './Header.module.css';

interface User {
  role: {
    name: string;
  };
}

interface HeaderProps {
  user: User | null;
}

const Header: React.FC<HeaderProps> = ({ user }) => {
  const [showIssueForm, setShowIssueForm] = useState(false);
  const [onlineMercenaries, setOnlineMercenaries] = useState<number>(0);
  const [battles24h, setBattles24h] = useState<number>(0);

  const handleReportIssue = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowIssueForm(true);
  };

  const handleCloseIssueForm = () => {
    setShowIssueForm(false);
  };

  useEffect(() => {
    const fetchOnlineMercenaries = async () => {
      try {
        const response = await axios.get('/api/user/online-count', { withCredentials: true });
        setOnlineMercenaries(response.data.count);
      } catch (error) {
        console.error('Error fetching online mercenaries:', error);
      }
    };

    const fetchBattles24h = async () => {
      try {
        const response = await axios.get('/api/user/battles-24h', { withCredentials: true });
        setBattles24h(response.data.count);
      } catch (error) {
        console.error('Error fetching 24h battles:', error);
      }
    };

    if (user) {
      fetchOnlineMercenaries();
      fetchBattles24h();
      // Update every 30 seconds
      const interval = setInterval(() => {
        fetchOnlineMercenaries();
        fetchBattles24h();
      }, 30000);
      return () => clearInterval(interval);
    }
  }, [user]);

  return (
    <>
      <header className={styles.banner}>
        <div className={styles.leftSection}>
          <Link to="/home">
            <h1 className={styles.logo}>Njordheim Arena</h1>
          </Link>
          {user && (
            <div className={styles.statsContainer}>
              <div className={styles.onlineCounter}>
                <span className={styles.onlineText}>Mercenaries Active: </span>
                <span className={styles.onlineCount}>{onlineMercenaries}</span>
              </div>
              <div className={styles.battlesCounter}>
                <span className={styles.battlesText}>Battles last 24h: </span>
                <span className={styles.battlesCount}>{battles24h}</span>
              </div>
            </div>
          )}
        </div>
        <div className={styles.topRightLinks}>
          <button
            className={styles.issueButton}
            onClick={handleReportIssue}
          >
            Report an Issue
          </button>
          {user?.role.name === 'Admin' || user?.role.name === 'Owner' ? (
            <Link to="/admin">Admin Page</Link>
          ) : null}
          {user?.role.name === 'Moderator' || user?.role.name === 'Admin' || user?.role.name === 'Owner' ? (
            <Link to="/moderator">Moderator Page</Link>
          ) : null}
        </div>
      </header>

      {showIssueForm && (
        <IssueReportForm
          onClose={handleCloseIssueForm}
          onSubmit={handleCloseIssueForm}
        />
      )}
    </>
  );
};

export default Header;
